var map = {
	"./black/quxiaoquantijingyin.png": "NaFP",
	"./blue/quxiaoquantijingyin.png": "Cly6",
	"./white/quxiaoquantijingyin.png": "4Cvs"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0Bc/";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/quxiaoquantijingyin\.png$
// module id = 0Bc/
// module chunks = 24